export default __webpack_public_path__ + "static/media/23.f8f45a5c.png";